import { clientMount } from '@vp/ubik-fragment-react'
import { MountWithRootOptions } from '@vp/ubik-fragment-types'
import {Root} from '../app/Root.js';
import React from 'react';

export const mount: MountWithRootOptions<any> = async (rootElement, ssrProps) => {
  return clientMount(<Root {...ssrProps} />, { rootElement })
}
